import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OnboardingLayout from '../../components/onboarding/OnboardingLayout';
import OptionButton from '../../components/onboarding/OptionButton';
import { useOnboarding } from '../../contexts/OnboardingContext';

const OnboardingStep12 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { responses, updateResponses, markStepCompleted } = useOnboarding();
  const [selected, setSelected] = useState<string[]>(responses.funExpenses || []);
  const progress = (12 / 14) * 100;

  const options = [
    { value: 'makan_luar', label: t('onboarding.step12.options.makan_luar'), emoji: '🍽️' },
    { value: 'hiburan', label: t('onboarding.step12.options.hiburan'), emoji: '🍿' },
    { value: 'game', label: t('onboarding.step12.options.game'), emoji: '🎮' },
    { value: 'berkebun', label: t('onboarding.step12.options.berkebun'), emoji: '🪴' },
    { value: 'hobi', label: t('onboarding.step12.options.hobi'), emoji: '🎲' },
  ];

  const toggleOption = (value: string) => {
    if (value === 'none') {
      setSelected([]);
      updateResponses('funExpenses', []);
      navigate('/onboarding/step-13');
      return;
    }

    setSelected(prev =>
      prev.includes(value)
        ? prev.filter(v => v !== value)
        : [...prev, value]
    );
  };

  const handleNext = () => {
    updateResponses('funExpenses', selected);
    markStepCompleted(12);
    navigate('/onboarding/step-13');
  };

  return (
    <OnboardingLayout progress={progress}>
      <div className="bg-white border-4 border-[#077f5d] p-8" style={{ boxShadow: '6px 6px 0 #077f5d' }}>
        <div className="mb-6">
          <h2 className="text-base text-center text-[#077f5d] mb-4 uppercase" style={{ fontFamily: "'Press Start 2P', monospace" }}>
            {t('onboarding.step12.title')}
          </h2>
        </div>

        <div className="space-y-3 mb-8">
          {options.map(option => (
            <OptionButton
              key={option.value}
              label={option.label}
              emoji={option.emoji}
              selected={selected.includes(option.value)}
              onClick={() => toggleOption(option.value)}
            />
          ))}
        </div>

        <button
          type="button"
          onClick={handleNext}
          disabled={selected.length === 0}
          className="w-full bg-[#3cbe8c] text-white px-8 py-4 border-2 border-[#077f5d] font-bold uppercase   hover:-translate-y-[2px] active:translate-y-[2px] active:shadow-none transition-all duration-75 disabled:opacity-50 disabled:cursor-not-allowed disabled:translate-y-0"
          style={{
            fontFamily: "'Press Start 2P', monospace",
            fontSize: '12px',
            boxShadow: '6px 6px 0 #077f5d'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '4px 4px 0 #077f5d';
            e.currentTarget.style.transform = 'translate(-2px, -2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '6px 6px 0 #077f5d';
            e.currentTarget.style.transform = 'translate(0, 0)';
          }}
        >
          {t('onboarding.step12.next')}
        </button>
      </div>
    </OnboardingLayout>
  );
};

export default OnboardingStep12;
